<template>
    <div class="bg-white relative rounded-lg hover:shadow-md transition duration-500 ease-in-out first:mt-0 mt-5">
        <div class="sm:grid grid-cols-12 xl:gap-6 gap-3 items-center">
            <div class="col-span-4 sm:rounded-l-lg sm:rounded-t-none rounded-t-lg h-full">
                <img
                    :src="article.index_image"
                    class="w-full lg:h-56 md:h-full sm:h-56 h-56 object-cover sm:rounded-l-lg sm:rounded-t-none rounded-t-lg"
                    :alt="article.title"
                />
            </div>
            <div class="col-span-8 md:px-6 sm:px-4 px-6 lg:py-0 md:py-6 sm:py-3 py-6">
                <span class="block text-xss uppercase text-gray-500">{{ article.category_name }}</span>
                <h4 class="lg:text-2xl text-xl overflow-hidden lg:max-h-19 mt-2">
                    {{ article.title }}
                </h4>
                <div class="single single-custom-content mt-1 sm:truncate" v-html="article.excerpt"></div>
                <div class="flex items-center text-gray-500 mt-4">
                    <p class="text-sm first:ml-0 ml-8">{{ article.published_at }}</p>
                    <div class="flex items-center tooltip first:ml-0 ml-8 z-1">
                        <svg
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="flex-shrink-0 w-4"
                        >
                            <path
                                d="M8.99551 0C4.023 0 0 4.02751 0 8.99998C0 13.9724 4.023 18 8.99551 18C13.968 18 18 13.9724 18 8.99998C18 4.02751 13.968 0 8.99551 0ZM8.99998 16.2C5.022 16.2 1.79997 12.978 1.79997 8.99998C1.79997 5.02195 5.022 1.80001 8.99998 1.80001C12.978 1.80001 16.2 5.022 16.2 8.99998C16.2 12.978 12.978 16.2 8.99998 16.2Z"
                                fill="#9B9B9B"
                            ></path>
                            <path
                                d="M9.44997 4.50003H8.09998V9.90003L12.8205 12.735L13.5 11.628L9.44997 9.22503V4.50003Z"
                                fill="#9B9B9B"
                            ></path>
                        </svg>
                        <span class="text-sm ml-2">{{ article.reading_time }}</span>
                        <div class="tooltip-text -ml-12 -mt-14">
                            <div class="bg-black text-white text-xs rounded py-px px-3">
                                Tiempo de lectura {{ article.reading_time }}
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 255 255"
                                    class="absolute text-black h-4 w-full left-0"
                                >
                                    <polygon points="0,0 127.5,127.5 255,0" class="fill-current"></polygon>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <user-favorites
                        class="first:ml-0 ml-8"
                        v-if="user"
                        :favoritable="article"
                        :user="user"
                        path="/revista"
                        :slug="article.slug"
                        :liked="false"
                        relation="articles"
                    ></user-favorites>
                </div>
            </div>
        </div>
        <a :href="article.link" class="absolute top-0 bottom-0 left-0 right-0 outline-none"></a>
    </div>
</template>
<script>
import UserFavorites from './UserFavorites';

export default {
    props: ['article', 'user'],

    components: { UserFavorites },
};
</script>
